import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-help-dialog',
  templateUrl: 'help-dialog.component.html',
})
export class HelpDialogComponent implements OnInit {
  @Input() imageName: string;
  @Input() innerHtml: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}
